// extracted by mini-css-extract-plugin
module.exports = {"cards":"styles_cards__Epzeu","title":"styles_title__c_PG-"};